// Module
var code = "<select chosen class=form-control ng-options=\"item.id as item.display_name for item in $ctrl.designationAccounts.data\" ng-model=$ctrl.designationAccounts.selected ng-change=$ctrl.onChange() placeholder-text-multiple=\"'Select Some Options' | translate\" multiple=multiple> </select> ";
// Exports
module.exports = code;